import {Routes} from '@angular/router';
import {FilesUploadPageComponent} from './upload/files-upload-page.component';
import {FilesViewPageComponent} from './view/files-view-page.component';
import {FilesWorkPageComponent} from './work/files-work-page.component';
import {FilesEducationPageComponent} from './education/files-education-page.component';

const routes: Routes = [{
    path: 'resume',
    children: (<Routes>[
        {path: '', redirectTo: 'upload', pathMatch: 'full'},
        {path: 'upload', component: FilesUploadPageComponent},
        {path: 'view/:id', component: FilesViewPageComponent},
        {path: 'work/:id/:entry', component: FilesWorkPageComponent},
        {path: 'education/:id/:entry', component: FilesEducationPageComponent}
    ]),
    data: {impersonationAllowed: true, impersonateRemoteId: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/resume-pages.routing.ts